function Logo() {
  return <h1>🌴 Travel Far Away 💼</h1>;
}

export default Logo;
